module.exports = __webpack_public_path__ + "img/success.894b80ec.svg";